import script from "./CustomDashboardProgressModuleContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardProgressModuleContent.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardProgressModuleContent.vue?vue&type=style&index=0&id=212719cf&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212719cf"]])

export default __exports__